// extracted by mini-css-extract-plugin
export var dropdown = "_vc-0";
export var imageWrapper = "_vc-3";
export var itemNameContainer = "_vc-1";
export var productImage = "_vc-2";
export var spinnerWrapper = "_vc-4";